import { Avatar, AvatarFallback, AvatarImage } from "@radix-ui/react-avatar";
import useAuthStore from "../../store/authStore";
import { Link } from "react-router-dom";
import { UserPen, BookUp2, LogOut } from "lucide-react";
import {  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger, } from "@radix-ui/react-dropdown-menu";

export default function ProfileHeader () {

  const { user, logout} = useAuthStore()
  return (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger>
    <Avatar className="cursor-pointer">
      <AvatarImage src={user.avatar_url} alt="@shadcn" className="rounded-full size-8" />
      <AvatarFallback>{user.name}</AvatarFallback>
    </Avatar>
    </DropdownMenuTrigger>
    <DropdownMenuContent className="shadow-md rounded-lg p-4 z-10 bg-white">
      <div className="px-2 font-semibold">
        Hello, {user.name}
      </div>
      <DropdownMenuSeparator className="bg-gray-400 h-px my-2"/>
      <Link to={"/profile"}>
      <DropdownMenuItem className="cursor-pointer p-2 hover:text-white hover:bg-blue-400/50 rounded-lg px-2">
        <div className="flex flex-row items-center gap-4">
        <div className="p-2 rounded-full bg-gray-100 size-max">
        <UserPen className="text-gray-800 "/>
        </div>
        <p>Hồ sơ cá nhân</p>
        </div>
      </DropdownMenuItem>
      </Link>
      <Link to={"/courses"}>
      <DropdownMenuItem className="cursor-pointer p-2 hover:text-white hover:bg-blue-400/50 rounded-lg px-2">
      <div className="flex flex-row items-center gap-4">
        <div className="p-2 rounded-full bg-gray-100 size-max">

        <BookUp2 className="text-gray-800 "/>
        </div>
        <p>Khóa học của tôi</p>
        </div>
      </DropdownMenuItem>
      </Link>
      <DropdownMenuItem className="cursor-pointer p-2 hover:text-white hover:bg-red-400/50 rounded-lg px-2" onClick={logout}>
      <div className="flex flex-row items-center gap-4">
        <div className="p-2 rounded-full bg-gray-100 size-max">

        <LogOut className="text-gray-800 "/>
        </div>
        <p>Đăng xuất</p>
        </div>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
  )
}
